import { extendObservable, action } from 'mobx';
import PropTypes from 'prop-types';

export default class MenuStore {
    static PropType = PropTypes.shape({
        id: PropTypes.any,
        open: PropTypes.func.isRequired,
        close: PropTypes.func.isRequired,
        toggle: PropTypes.func.isRequired,
        isOpen: PropTypes.func.isRequired,
        getValue: PropTypes.func.isRequired,
    });

    constructor(data = {}) {
        const set = action((value) => { this.id = value; });

        extendObservable(this, /** @class MenuStore */{
            id: null,
            set,
            open: set,
            close: () => {
                this.id = null;
            },
            toggle: (id) => {
                if (this.id === id) {
                    this.id = null;
                } else {
                    this.id = id;
                }
            },
            isOpen() {
                return this.id !== null;
            },
            getValue: () => this.id,
        }, data);
    }
}
